import React, {lazy} from 'react';
import {withRouter, Route, Switch, Redirect} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {withStyles} from '@material-ui/core/styles';
import styles from "assets/jss/views/appStyle.jsx";
import { Security, LoginCallback } from '@okta/okta-react';
import { OktaAuth } from '@okta/okta-auth-js';
import { SecureRoute } from '@okta/okta-react';
import 'assets/css/index.css';
import "assets/css/material-react.css?v=1.8.0";
import { userService } from '../../services/userService';

const NoAccountPage = lazy(() => import('layouts/NoAccount'));
const NoRightsPage = lazy(() => import('layouts/NoRights'));
const NoThetrawinPage = lazy(() => import('layouts/NoThetrawin'));
const NotFoundPage = lazy(() => import('layouts/404'));
const Global = lazy(() => import('layouts/Global'));
const Auth = lazy(() => import('layouts/Auth'));
const Pdf = lazy(() => import('layouts/Pdf'));
const Files = lazy(() => import('layouts/Files'));
const Admin = lazy( () => import('views/Admin'));
const Pdf_TMP = lazy(() => import('layouts/Pdf_TMP'));

type AppProps = {
  history: any,
 };

 const { REACT_APP_OKTA_DOMAIN, REACT_APP_OKTA_CLIENT_ID, REACT_APP_OKTA_CALLBACK_PATH } = process.env;
 
 const ISSUER = `https://${REACT_APP_OKTA_DOMAIN}/oauth2/default`; 
 const REDIRECT_URI = `${window.location.origin}${REACT_APP_OKTA_CALLBACK_PATH}`;
 const SCOPES = 'openid profile email';


class App extends React.Component<AppProps> {

  /*componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.log(error);
    console.log(errorInfo);
  }*/

  render() {

    const user = JSON.parse(localStorage.getItem('user')||'{}')

    const config = {
      issuer: ISSUER,
      clientId: REACT_APP_OKTA_CLIENT_ID,
      redirectUri: REDIRECT_URI,
      scopes: SCOPES.split(/\s+/)
    };

    const oktaAuth = new OktaAuth(config);

    const restoreOriginalUri = () => {
      userService.login().then(data => {
        this.props.history.push({
          pathname: '/'
        })
      })
      .catch(err => {
        if (err==="thetrawin") {
          this.props.history.push({
            pathname: '/nothetrawin'
          })
        }

        this.props.history.push({
          pathname: '/noaccount'
        })
        //oktaAuth.signOut();
      })
    };

    return (
      <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
        <Switch>
          <SecureRoute path="/app" component={Global} />
          <SecureRoute path='/logas/:id' component={Auth} />
          {user.offerboard &&
            <Redirect from="/" to="/app/home" exact/>
          }
          {(!user.offerboard&&user.insurance) &&
            <Redirect from="/" to="/app/insurances" exact/>
          }
          {(!user.offerboard&&!user.insurance&&user.ar) && 
            <Redirect from="/" to="/app/ar" exact/>
          }
          {(!user.offerboard&&!user.ar&&!user.insurance) &&
            <Redirect from="/" to="/norights" exact/>
          }
          <Route path={REACT_APP_OKTA_CALLBACK_PATH} component={LoginCallback}/>
          <SecureRoute path="/norights" component={NoRightsPage} />
          <Route path="/noaccount" component={NoAccountPage} />
          <Route path="/nothetrawin" component={NoThetrawinPage} />
          <SecureRoute path='/pdf/:id' component={Pdf} />
          <SecureRoute path='/files' component={Files} />
          <SecureRoute path="/admin" component={Admin} />
          <Route path="/tmp" component={Pdf_TMP} />
          <Route component={NotFoundPage} />
        </Switch>
      </Security>
    );
  } 
}

export default withTranslation()(
  withStyles(styles)(withRouter(App))
);